import React, {useState, useEffect} from "react";

import DownModal from "../layouts/DownModal";

import {WebLink, SiteWide} from "../customComponents";
import { useSelector, useDispatch } from 'react-redux';

import {authActions} from '../../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect} from '../../redux/selectors/index';
import Helper1, {notify, money, customNormalModalStyles} from '../../utility/Helper1';
import {homepage} from '../../utility/APIRequests';

import SelectCurrency from "../customComponents/SelectCurrency";


import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Images} from "../customComponents";
import { AiOutlineWallet } from "react-icons/ai";
import {systemColor} from '../../utility/styles';
import  './style.css';
import { FiEdit2 } from "react-icons/fi";

import PinAuth from "../customComponents/PinAuth";
import { useLocation } from 'react-router-dom';

import FullScreenInputHolder from "../customComponents/FullScreenInputHolder";
import SVGImage from "../../images/mc.svg";
const SVGImage2 = require('../../images/creditcardbg.jpg')





function Wallet({history}){

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const [financeEditing, setFinanceEditing]   = useState(0);
    const [walletModal, setWalletModal]   = useState(false);
    const [googleAuth, setGoogleAuth]   = useState('');

    const [emailOTP, setEmailOTP]   = useState('');
    const [phoneModal, setPhoneModal]   = useState(false);
    
    const [phone, setPhone]   = useState(userData?.phone ?? '');
    const [phoneCode, setPhoneCode]   = useState('...');
    const [country, setCountry]             = useState(userData?.country ?? ''); //'156'

    const [passwordModal, setPasswordModal]   = useState(false);
    const [loading, setloading]   = useState();
    const [loadingText, setLoadingText]   = useState('Loading...');

    const [password, setPassword]       = useState('');

    
    
    const [bank, setBank]       = useState(userData?.bank ?? '');
    const [accountName, setAccountName]       = useState(userData?.accountName ?? '');
    const [accountNumber, setAccountNumber]       = useState(userData?.accountNumber ?? '');
    const [iban, setIban]       = useState(userData?.iban ?? '');


    const [usdttrc20wallet, usdttrc20walletSet]       = useState( '');
    const [btcwallet, btcwalletSet]       = useState('');
    const [bchwallet, bchwalletSet]       = useState('');
    const [ethwallet, ethwalletSet]       = useState('');
    const [ltcwallet, ltcwalletSet]       = useState('');
    const [usdcwallet, usdcwalletSet]       = useState('');
    const [xrpwallet, xrpwalletSet]       = useState('');
    const [adawallet, adawalletSet]       = useState('');
    const [dogewallet, dogewalletSet]       = useState('');
    const [dashwallet, dashwalletSet]       = useState('');
    const [xtzwallet, xtzwalletSet]       = useState('');
    const [dotwallet, dotwalletSet]       = useState('');
    const [linkwallet, linkwalletSet]       = useState('');
    const [xlmwallet, xlmwalletSet]       = useState('');
    const [etcwallet, etcwalletSet]       = useState('');
    const [uniwallet, uniwalletSet]       = useState('');
    const [pmwallet, pmwalletSet]       = useState('');
    const [bnbwallet, bnbwalletSet]       = useState('');

    const [securityObj, setSecurityObj] = useState({})
    const [currencySelected, setCurrencySelected]   = useState(finance?.[0]);
    const [currencyModal, setCurrencyModal]   = useState('');

    const { pathname } = useLocation();







    // determine the page we land on
    const isItBankPlace = pathname == '/bank'?true:false






    const [editPanel, setEditPanel]   = useState('');


    const systemColorManager = systemColor()

    const dispatch = useDispatch();

    
    const toggleEditPanel = () => {
        setEditPanel(!editPanel)
    }

    const doAddressChange = (e) => {
        setloading(true);
        e.preventDefault();

        let updateObject = {...(securityObj ?? {}), usdttrc20wallet, btcwallet, bchwallet, ethwallet, ltcwallet, usdcwallet, xrpwallet, adawallet, dogewallet, dashwallet, xtzwallet, dotwallet, linkwallet, xlmwallet, etcwallet, uniwallet, pmwallet, bnbwallet}

        dispatch(authActions.onLogin(`account/account_change/1`, updateObject, response => {
            notify(response.msg, response.code)
            setloading(false);
            if(response.code == 1){
                toggleEditPanel()
            }
        }),
        );
    }


    const doBankUpdate = (e) => {
        
        e.preventDefault();
        setloading(true);

        let updateObject;

        updateObject = {iban, bank, accountName, accountNumber, ...(securityObj ?? {}),}

        dispatch(authActions.onLogin(`account/account_change/0`, updateObject, response => {
            notify(response.msg, response.code)
            setloading(false);
            if(response.code == 1){
                toggleEditPanel()
            }
        }),
        );
    }





    const updateCurrencySelected = (newCurObj) => {
        setCurrencySelected(newCurObj)
    }

    const toggleCurrencyModal = () => {
        setCurrencyModal(!currencyModal)
    }



    useEffect(() => {
       let mat =  userData?.bankdetails?.map((item, detail) => eval(item?.valueJsConstFunction)(item.value));
    }, [])

    const walletDetails = userData?.bankdetails?.filter((eachWallet, theIndex) => eachWallet.abbr == currencySelected.abbr)


    const showAccountName = accountName == ''?'Account Name':accountName
    const showAccountNumber = accountNumber == ''?'XXXXXXXXXXXXXXX':accountNumber
    const showIban = iban == ''?'IBAN':iban


    const editIcon = <div onClick={toggleEditPanel}  className="cursor-pointer" style={{marginRight: 10}}>
        <FiEdit2 size={20} />

    </div>
    

    return (
        <SiteWide additionalTopIcons={editIcon} title={isItBankPlace?`Bank manager`:`Payment Address`}>
                



             {!isItBankPlace && 1>2 && <div>
                <button className="btn btn-info flexify" style={{color: '#000', borderRadius: 30}} onClick={toggleCurrencyModal}>
                    <AiOutlineWallet />
                    <div>{currencySelected.name}</div>
                </button>
            </div>}

            










<main style={{marginTop: 120}} id="app">
  
  
  <aside class="card-front" style={{backgroundImage: `url(${(isItBankPlace?SVGImage:SVGImage2)})`}}>
    <label class="number" for="cardNumber">
        {isItBankPlace?showAccountNumber:(walletDetails?.[0]?.value ?? '' !='') ?walletDetails?.[0]?.value: 'XXXXXXXXXXXXXXX'}
    </label>
    <label class="name" style={{minWidth: '100%'}} for="cardHolder">
        {isItBankPlace?showAccountName:`${userData.username}`}
    </label>
    <label class="expiry" for="expiryMonth" >
        {isItBankPlace?showIban:'USDT'}
    </label>
    <img class="cardLogo" data-v-5d206127="" data-v-8fcb32d4="" style={{opacity: 1}} src={require('../../images/mastercard.png')} />
    <span style={{position: 'absolute', top: 65, right: 25, color: '#fff', fontSize: 12}} cslassName="name">{isItBankPlace?bank:currencySelected.name}</span>
    
      
    <div class="chip">
      <svg role="img" viewBox="0 0 100 100" aria-label="Chip">
        <use href="#chip-lines" />
      </svg>
    </div>
    <svg class="contactless" role="img" viewBox="0 0 24 24" aria-label="Contactless">
      <use href="#contactless" />
    </svg>
    
  </aside>
  
</main>





<svg id="chip">
  <g id="chip-lines">
    <polyline points="0,50 35,50"></polyline>
    <polyline points="0,20 20,20 35,35"></polyline>
    <polyline points="50,0 50,35"></polyline>
    <polyline points="65,35 80,20 100,20"></polyline>
    <polyline points="100,50 65,50"></polyline>
    <polyline points="35,35 65,35 65,65 35,65 35,35"></polyline>
    <polyline points="0,80 20,80 35,65"></polyline>
    <polyline points="50,100 50,65"></polyline>
    <polyline points="65,65 80,80 100,80"></polyline>
  </g>
</svg>


<svg id="contactless">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <path d="M9.172 15.172a4 4 0 0 1 5.656 0"></path>
   <path d="M6.343 12.343a8 8 0 0 1 11.314 0"></path>
   <path d="M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"></path>
</svg>




                

            {/* <FullScreenInputHolder> */}
            <DownModal containerStyle={{...systemColorManager.bg_1}} isOpen={editPanel} onClose={toggleEditPanel}>
                





                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <div className="" style={{maxHeight: 'auto', width: '100%', paddingBottom: 100}}>

                        


                        {!isItBankPlace && <form onSubmit={doAddressChange}>

                            <div>

                                <div>
                                    {userData?.bankdetails?.filter((eachItem) => (eachItem.abbr == currencySelected.abbr))?.map((item, detail) => <div className="single-input-wrap">

                                        <span className="new-input-label" style={{...systemColorManager.txt_1}}>{item?.abbr} wallet</span>
                                        <input value={eval(item.valueJsConst)} placeholder={item?.name} onChange = {e => eval(item?.valueJsConstFunction)(e.target.value) } required="" className="form-field form-control" style={{...systemColorManager.borders_color, ...systemColorManager.bg_3}} type="text" />
                                    
                                    </div>)}
                                </div>

                                <PinAuth resultingObjMethod={setSecurityObj} userData={userData} />

                            </div>

                            <div>
                                <button type="submit" disabled={loading} className="btn" style={{...systemColorManager.btn_3}}>
                                Save </button>
                            </div>
                            
                        </form>}







                        {isItBankPlace && <form onSubmit={doBankUpdate}>
                            
                            <div class="single-input-wrap">
                                <span className="new-input-label" style={{...systemColorManager.txt_1}}>Bank Name</span>
                                <input value={bank} placeholder="Bank" onChange = {e => setBank(e.target.value) } required="" className="form-field form-control" type="text" style={{...systemColorManager.borders_color, ...systemColorManager.bg_3}}/>
                            </div>

                            <div class="single-input-wrap">
                                <span className="new-input-label" style={{...systemColorManager.txt_1}}>Account Name</span>
                                <input value={accountName} placeholder="Account Name" onChange = {e => setAccountName(e.target.value) } required="" className="form-field form-control" type="text" style={{...systemColorManager.borders_color, ...systemColorManager.bg_3}}/>
                            </div>

                            <div class="single-input-wrap">
                                <span className="new-input-label" style={{...systemColorManager.txt_1}}>Account Number</span>
                                <input value={accountNumber} placeholder="Account Number" onChange = {e => setAccountNumber(e.target.value) } required="" className="form-field form-control" type="text" style={{...systemColorManager.borders_color, ...systemColorManager.bg_3}}/>
                            </div>

                            <div class="single-input-wrap">
                                <span className="new-input-label" style={{...systemColorManager.txt_1}}>IBAN</span>
                                <input value={iban} placeholder="IBAN" onChange = {e => setIban(e.target.value) } required="" className="form-field form-control" type="text" style={{...systemColorManager.borders_color, ...systemColorManager.bg_3}}/>
                            </div>

                            <PinAuth resultingObjMethod={setSecurityObj} userData={userData} />

                            <button type="submit" disabled={loading} className="btn mt-40 btn-block btn-danger" style={{...systemColorManager.btn_3}}>
                                Save
                            </button>

                        </form>}



                    </div>
                </div>

            </DownModal>

            {/* </FullScreenInputHolder> */}



            <SelectCurrency selectedObj={currencySelected} curArrayToLoop={finance} isOpen={currencyModal} closeCurrencyModal={toggleCurrencyModal} onSelectCurrency={updateCurrencySelected} />



        </SiteWide>
    );

}

export default Wallet;